/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcProxyvoteV1ProxyTaskEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_PROXYVOTE_V1_PROXY_TASK_EVENT_ENTITY_NAME = 'ixc.proxyvote.v1.ProxyTaskEvent';
export const ixcProxyvoteV1ProxyTaskEventEntity = new schema.Entity<IxcProxyvoteV1ProxyTaskEvent>(IXC_PROXYVOTE_V1_PROXY_TASK_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcProxyvoteV1ProxyTaskEvent) => `${entity.metadata?.eventId}` });

